import * as _ from 'lodash';
var SimulateVariableStore = /** @class */ (function () {
    function SimulateVariableStore(variables) {
        this.variables = variables;
    }
    SimulateVariableStore.prototype.getVariableName = function (args) {
        var variable = _.find(this.variables, function (l) { return l.dataSourceCode === args.code
            && l.fBoxGroupName === args.groupName && l.fBoxVariableName === args.name; });
        if (variable !== undefined) {
            return variable.variableName;
        }
        return undefined;
    };
    return SimulateVariableStore;
}());
export { SimulateVariableStore };
